import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
// import CheckboxWithLabel from "Components/formControls/CheckboxWithLabel";
import { useFormContext } from "react-hook-form";
import { checkArrayLength } from "src/utils";
import useStyles from "../../styles";
import { useTranslation } from "react-i18next";
import EditQuestions from "./EditQuestions";

const CustomQuestions = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();
  const { configuration, disabledView } = watch();
  const [addButtonToggle, setAddButtonToggle] = useState(false);
  const addNewQuestion = () => {
    const allCustomQuestion = [
      ...(configuration?.onboardingQuestions?.custom || []),
    ];
    if (allCustomQuestion.every((res) => res.question)) {
      const data = [
        ...allCustomQuestion,
        {
          isSelected: "",
          isDefault: false,
          question: "",
          answer: "",
        },
      ];
      setValue(`configuration.onboardingQuestions.custom`, data);
    }
    setAddButtonToggle((value) => !value);
  };
  useEffect(() => {
    setAddButtonToggle(
      configuration?.onboardingQuestions?.custom.some(
        (res) => !res.question.trimLeft()
      )
    );
  }, [
    configuration?.onboardingQuestions?.custom.some(
      (res) => !res.question.trimLeft()
    ),
  ]);
  return (
    <Box className={classes.root}>
      <Accordion className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel5a-content"
          id="panel5a-header"
          className={classes.accordionSummary}
        >
          <Typography className={classes.heading}>
            {/* {accordionHeading} */}
            Custom questions
            <span className="f-gray font-12 font-regular ml10">
              (
              {checkArrayLength(
                configuration?.onboardingQuestions?.custom.filter(
                  (res) => res.isSelected
                )
              )}{" "}
              selected)
            </span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          {disabledView ? (
            ""
          ) : (
            <Box width="100%" textAlign="right">
              <Button
                data-testid="add"
                color="primary"
                disabled={addButtonToggle}
                // disabled={disabledView}

                onClick={addNewQuestion}
                size="small"
              >
                Add question
              </Button>
            </Box>
          )}

          {[...(configuration?.onboardingQuestions?.custom || [])].map(
            (question, index) => (
              <Box mt={1}>
                <EditQuestions
                  name="configuration.onboardingQuestions.custom"
                  question={question}
                  index={index}
                />
              </Box>
            )
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default CustomQuestions;
